var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { Icon } from "../../UI";

import { Translate } from "../../I18N";
import { Select } from "../../ReactReduxForms";
import Tip from "../../Layout/Tip";

import { FilterSuggestions } from "./FilterSuggestions";
import PropertyConfigOption from "./PropertyConfigOption";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";

const style = (index) => /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
_jsx("label", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Style")
), /*#__PURE__*/
_jsx(Select, {
  model: `template.data.properties[${index}].style`,
  options: [
  { _id: 'contain', name: 'Fit' },
  { _id: 'cover', name: 'Fill' }],

  optionsLabel: "name",
  optionsValue: "_id" }
)
), /*#__PURE__*/
_jsx("div", { className: "protip" }, void 0, /*#__PURE__*/
_jsx("p", {}, void 0, /*#__PURE__*/
_jsx("b", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Fit")
), "\xA0", /*#__PURE__*/

_jsx(Translate, { translationKey: "Multimedia fit description" }, void 0, "will show the entire media inside the container."

), /*#__PURE__*/
_jsx("br", {}), /*#__PURE__*/
_jsx("b", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Fill")
), "\xA0", /*#__PURE__*/

_jsx(Translate, { translationKey: "Multimedia fill description" }, void 0, "will attempt to fill the container, using its entire width. In cards, cropping is likely to occur."


)
)
)
);


class FormConfigMultimedia extends Component {
  render() {
    const { index, canShowInCard, helpText, canSetStyle, canBeRequired, labelHasError } =
    this.props;

    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
      _jsx("label", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { className: "form-control" })
      )
      ),

      helpText && /*#__PURE__*/
      _jsx("div", { className: "protip" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "lightbulb" }), /*#__PURE__*/
      _jsx("span", {}, void 0, helpText)
      ), /*#__PURE__*/


      _jsx(PropertyConfigOption, {
        label: "Hide label",
        model: `template.data.properties[${index}].noLabel` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This property will be shown without the label.")
      )
      ), /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Full width",
        model: `template.data.properties[${index}].fullWidth` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This property will be shown using all the width available.")
      )
      ),
      canBeRequired && /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Required property",
        model: `template.data.properties[${index}].required` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "empty property tip" }, void 0, "You won't be able to save an entity if this property is empty."

      )
      )
      ),

      canShowInCard && /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Show in cards",
        model: `template.data.properties[${index}].showInCard` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "This property will appear in the library cards as part of the basic info."

      )
      )
      ),


      canSetStyle && style(index), /*#__PURE__*/
      _jsx(FilterSuggestions, { index: index })
      ));

  }
}

FormConfigMultimedia.defaultProps = {
  canShowInCard: true,
  canSetStyle: true,
  canBeRequired: true,
  labelHasError: false,
  helpText: ''
};










export function mapStateToProps(state, props) {
  return {
    labelHasError: checkErrorsOnLabel(state, props)
  };
}

export default connect(mapStateToProps)(FormConfigMultimedia);